// utils/clipboard.js
// Compatible with both HTTPS (production) and HTTP (dev) environments

export const copyToClipboard = (text, onSuccess, onError) => {
  // Try modern Clipboard API (HTTPS/localhost only)
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(text)
      .then(() => { if (onSuccess) onSuccess(); })
      .catch((err) => {
        console.warn('Clipboard API failed, using fallback:', err);
        legacyCopy(text, onSuccess, onError);
      });
    return;
  }

  // Fallback: legacy method (works on HTTP)
  legacyCopy(text, onSuccess, onError);
};

function legacyCopy(text, onSuccess, onError) {
  const textArea = document.createElement('textarea');
  textArea.value = text;
  textArea.style.position = 'fixed';
  textArea.style.left = '-999999px';
  textArea.style.top = '-999999px';
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    document.execCommand('copy');
    if (onSuccess) onSuccess();
  } catch (err) {
    console.error('Fallback copy failed:', err);
    if (onError) onError(err);
  } finally {
    document.body.removeChild(textArea);
  }
}
